export const root = "reartu2";
export const widthControl = "wipz4lj";
export const imageWrapper = "i1lqa152";
export const image = "i6katie";
export const truncate = "t64q6zk";
export const divider = "d1yo7qui";
export const text = "t1yvjbf9";
export const subtitle = "scktssa";
export const guidePhoto = "g63bt3k";
export const notes = "nf39tot";
export const detailsContainer = "d1p137bz";
export const calendarIcon = "cswdiwj";
export const imageDescriptor = "ik5j0cg";

require("./style.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./style.tsx");